import React from "react";
import Title from "./Title";
import UserField from "./UserField";

export default function UserInfo(props) {
  const getList = () => {
    var get = require("lodash.get");

    return props.options.itemList.map((option, index) => {
      return (
        <UserField
          option={option}
          value={get(props.userData, option.name)}
          handleChange={props.handleChange}
          getRandomCard={props.getRandomCard}
          addCollectionAsset={props.addCollectionAsset}
          updateLeagueRank={props.updateLeagueRank}
          updateLeaderboardRank={props.updateLeaderboardRank}
          resetCardCollection={props.resetCardCollection}
          resetLeague={props.resetLeague}
          addLeagueBots={props.addLeagueBots}
          addLeaderboardBots={props.addLeaderboardBots}
          addTrophyLeaderboardBots={props.addTrophyLeaderboardBots}
          setEvent={props.setEvent}
          eventType={props.eventType}
          eventStartTime={props.eventStartTime}
          eventEndTime={props.eventEndTime}
          userPageLoading={props.userPageLoading}
          setPacks = {props.setPacks}
          questNumber = {props.questNumber}
          packID = {props.packID}
          packProgress = {props.packProgress}
          packClaimStatus = {props.packClaimStatus}
        />
      );
    });
  };
  return (
    <React.Fragment>
      <Title>{props.options.sectionTitle}</Title>
      <br />
      {getList()}
    </React.Fragment>
  );
}
